import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics/ga";

/**
 * Mounts inside <BrowserRouter>. Fires a GA4 page_view on every route change.
 * Renders nothing.
 */
const RouteAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    // Defer one tick so document.title (set by Helmet) reflects the new route.
    const id = window.setTimeout(() => trackPageView(path), 0);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
};

export default RouteAnalytics;
